import React from 'react'
import { TfiClose } from "react-icons/tfi"
import useAppContext from '../../hook/useAppContext'
import './modal.css'

const Modal = () => {

      const {imgObj, modal, setModal} = useAppContext() 

      if(!modal) return 

      return (
            <div className={modal ? "modal_content show" : "modal_content"}>
                  <div className="modal_inner flex">
                        <img src={imgObj.url} alt={imgObj.title} />
                  </div>
                  <button className="close_modal flex" onClick={() => setModal(false)}><TfiClose /></button>
            </div>
      )
}

export default Modal
